import { NgClass, NgIf } from '@angular/common'
import {
    SERVICE_STATUS_CLASS_NAMES,
    SERVICE_STATUS_LABELS,
    ServiceStatus,
} from '@app/domain/ServiceStatus'
import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

const SERVICE_STATUS_ICON_PATHS: Partial<Record<ServiceStatus, string>> = {
    [ServiceStatus.Drinks]: 'assets/service-status/drinks.svg',
    [ServiceStatus.Starter]: 'assets/service-status/starter-main-dessert.svg',
    [ServiceStatus.Main]: 'assets/service-status/starter-main-dessert.svg',
    [ServiceStatus.Dessert]: 'assets/service-status/starter-main-dessert.svg',
    [ServiceStatus.Bill]: 'assets/service-status/bill.svg',
    [ServiceStatus.Cleaning]: 'assets/service-status/cleaning.svg',
    [ServiceStatus.Paid]: 'assets/service-status/paid.svg',
}

export type ServiceStatusBadgeVariant = 'title' | 'icon' | 'title-and-icon'
export type ServiceStatusBadgeAppearance = 'auto' | 'light' | 'dark'
export type ServiceStatusBadgeSize = 'regular' | 'large'

@Component({
    selector: 'app-service-status-badge',
    standalone: true,
    templateUrl: './service-status-badge.component.html',
    styleUrls: ['./service-status-badge.component.sass'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgClass,
        NgIf,
    ],
})
export class ServiceStatusBadgeComponent {

    @Input() serviceStatus: ServiceStatus | null = null
    @Input() variant: ServiceStatusBadgeVariant = 'title-and-icon'
    @Input() appearance: ServiceStatusBadgeAppearance = 'auto'
    @Input() size: ServiceStatusBadgeSize = 'regular'

    get label(): string {
        if (this.serviceStatus === null) {
            return ''
        }
        return SERVICE_STATUS_LABELS[this.serviceStatus]
    }

    get statusClass(): string {
        if (this.serviceStatus === null) {
            return ''
        }
        return SERVICE_STATUS_CLASS_NAMES[this.serviceStatus]
    }

    get iconPath(): string | null {
        if (this.serviceStatus === null) {
            return null
        }
        return SERVICE_STATUS_ICON_PATHS[this.serviceStatus] ?? null
    }

    get iconMaskValue(): string | null {
        if (this.iconPath === null) {
            return null
        }
        return `url("${this.iconPath}")`
    }

    get showsIcon(): boolean {
        return this.variant !== 'title' && this.iconPath !== null
    }

    get showsTitle(): boolean {
        return this.variant !== 'icon'
    }
}